import React, { useEffect, useState } from 'react';
import { Redirect } from '@react-router';
import { EventType } from '@graphql/generated';
import { useAuth } from '@shared/components/AuthProvider';
import { JoyLogoLoader } from '../JoyLogoLoader';
import { useManagedSearchParam } from '@apps/admin/common/hooks/useManagedSearchParam';

const EMAIL_VERIFICATION_SUCCESS_MESSAGE = 'Your email was verified. You can continue using the application.';
export const EMAIL_VERIFICATION_SUCCESS_PARAM_VALUE = 'emailVerificationSuccess';

export const AccountRedirect = () => {
  const authProvider = useAuth();
  const [loading, setLoading] = useState(true);
  const [pathRedirect, setPathRedirect] = useState<string>('/account/events');

  const { isCurrentUserSettled, isLoggedIn, currentUser } = authProvider;

  const [messageSearchParam] = useManagedSearchParam('message');
  const [emailVerifiedParamValue] = useManagedSearchParam('emailVerified');

  useEffect(() => {
    if (isCurrentUserSettled && !isLoggedIn) {
      return authProvider.loginManager.authService.authorize(window.location.href);
    }

    // TODO: remove messageSearchParam after we add emailVerified param to the auth0 redirect url
    const searchParams = messageSearchParam === EMAIL_VERIFICATION_SUCCESS_MESSAGE || emailVerifiedParamValue === 'true' ? `?${EMAIL_VERIFICATION_SUCCESS_PARAM_VALUE}=true` : '';

    const event = currentUser.eventMemberships[0]?.event;
    if (currentUser.eventMemberships.length === 1 && event) {
      const isBabyRegistry = event.info.eventType === EventType.babyRegistry;
      setPathRedirect(`/${event.website}/edit${isBabyRegistry ? '/registry' : ''}${searchParams}`);
    } else if (searchParams) {
      setPathRedirect(`/account/events${searchParams}`);
    }

    if (isCurrentUserSettled) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCurrentUserSettled, currentUser, authProvider.loginManager.authService, isLoggedIn]);

  return loading ? <JoyLogoLoader loaderKey="account-redirect" /> : <Redirect to={pathRedirect} />;
};
